/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React from 'react';
import { Stack, Select, Text, Box } from '@chakra-ui/core';
import { HiOutlineTrash } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';
import { QuestionnaireTemplateStore } from '../../../store/questionnaireTemplateModel';
import { ConfirmPopover } from '../../../../../common/ConfirmPopover/ConfirmPopover';
import colors from '../../../../../../styles/colors';
import { Branch, QUESTIONNAIRE_ELEMENT_TYPE } from '../../../questionnaireTemplate.enums';
import { formElementSchema } from '../../schemas/formElement.schema';

const INLINE_SELECT_PROPS = {
  size: 'sm',
  variant: 'filled',
  width: 'fit-content',
  minW: 'unset',
  mx: 1,
  pl: 1,
  cursor: 'pointer',
  fontSize: 'sm',
} as const;
interface BranchLabelProps {
  parentId: string;
  branchName: Branch;
  isOnlyBranch: boolean;
  availableOptions: string[];
}

export const BranchLabel = React.memo(function BranchLabel({
  parentId,
  branchName,
  isOnlyBranch,
  availableOptions,
}: BranchLabelProps) {
  const { t } = useTranslation('questionnaireTemplate');
  const questionTypeSelector = React.useCallback((state) => state.getElementValue(parentId, 'questionType'), [parentId]);
  const questionType = QuestionnaireTemplateStore.useStoreState<QUESTIONNAIRE_ELEMENT_TYPE>(questionTypeSelector);
  const switchBranch = QuestionnaireTemplateStore.useStoreActions((a) => a.switchBranch);
  const removeBranch = QuestionnaireTemplateStore.useStoreActions((a) => a.removeBranch);

  const availableBranches = formElementSchema[questionType]?.branches;

  if (!availableBranches?.length) return null;

  const branchNameTranslated = t(`formBuilder.schema.yesno.branches.${availableBranches.indexOf(branchName)}`);

  return (
    <Stack isInline align="center" justify="space-between" mb={2} width="100%">
      <Stack isInline align="center">
        <Text fontSize="xs" fontWeight="bold" color="gray.500">
          {t('formBuilder.canvas.element.followNextQuestion')}
        </Text>
        {isOnlyBranch ? (
          <Select
            {...INLINE_SELECT_PROPS}
            value={branchName}
            textTransform="capitalize"
            onChange={(e) => switchBranch({ elementId: parentId, oldBranch: branchName, newBranch: e.target.value as Branch })}
          >
            {availableOptions.map((opt) => (
              <option key={opt} value={opt}>
                {t(`formBuilder.schema.yesno.branches.${availableBranches.indexOf(opt)}`)}
              </option>
            ))}
          </Select>
        ) : (
          <Text fontSize="xs" fontWeight="bold" color="gray.700" textTransform="uppercase">
            {branchNameTranslated}
          </Text>
        )}
        <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase">
          :
        </Text>
      </Stack>
      <ConfirmPopover
        message="Are you sure you want to delete the section? It will be deleted all the questions inside."
        aria-label="Delete branch"
        onConfirm={() => {
          removeBranch({ elementId: parentId, branchName });
        }}
      >
        <Box as="button" display="flex">
          <HiOutlineTrash fontSize={24} color={colors.gray[600]} cursor="pointer" />
        </Box>
      </ConfirmPopover>
    </Stack>
  );
});
